export function highlightJson(json: string): string {
  let highlighted = json
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  highlighted = highlighted.replace(/"([^"\\]|\\.)*"\s*:/g, (match) => {
    const key = match.substring(0, match.lastIndexOf(':'));
    return `<span class="text-teal-400">${key}</span>:`;
  });

  highlighted = highlighted.replace(/:\s*"([^"\\]|\\.)*"/g, (match) => {
    const colonIndex = match.indexOf(':');
    const colonPart = match.substring(0, colonIndex + 1);
    const spacesMatch = match.substring(colonIndex + 1).match(/^\s*/);
    const spaces = spacesMatch ? spacesMatch[0] : '';
    const value = match.substring(colonIndex + 1).trim();
    return `${colonPart}${spaces}<span class="text-green-400">${value}</span>`;
  });

  highlighted = highlighted.replace(/([,[])\s*"([^"\\]|\\.)*"/g, (match) => {
    const prefix = match[0];
    const spacesMatch = match.substring(1).match(/^\s*/);
    const spaces = spacesMatch ? spacesMatch[0] : '';
    const value = match.substring(1).trim();
    return `${prefix}${spaces}<span class="text-green-400">${value}</span>`;
  });

  highlighted = highlighted.replace(/:\s*(-?\d+\.?\d*)/g, (match, number) => {
    const colonIndex = match.indexOf(':');
    const colonPart = match.substring(0, colonIndex + 1);
    const spaces = match.substring(colonIndex + 1, match.indexOf(number));
    return `${colonPart}${spaces}<span class="text-blue-400">${number}</span>`;
  });

  highlighted = highlighted.replace(
    /([,[])\s*(-?\d+\.?\d*)/g,
    (match, prefix, number) => {
      const spaces = match.substring(1, match.indexOf(number));
      return `${prefix}${spaces}<span class="text-blue-400">${number}</span>`;
    },
  );

  highlighted = highlighted.replace(/:\s*(true|false)/g, (match, bool) => {
    const colonIndex = match.indexOf(':');
    const colonPart = match.substring(0, colonIndex + 1);
    const spaces = match.substring(colonIndex + 1, match.indexOf(bool));
    return `${colonPart}${spaces}<span class="text-purple-400">${bool}</span>`;
  });

  highlighted = highlighted.replace(
    /([,[])\s*(true|false)/g,
    (match, prefix, bool) => {
      const spaces = match.substring(1, match.indexOf(bool));
      return `${prefix}${spaces}<span class="text-purple-400">${bool}</span>`;
    },
  );

  highlighted = highlighted.replace(/:\s*(null)/g, (match, nullVal) => {
    const colonIndex = match.indexOf(':');
    const colonPart = match.substring(0, colonIndex + 1);
    const spaces = match.substring(colonIndex + 1, match.indexOf(nullVal));
    return `${colonPart}${spaces}<span class="text-neutral-500">${nullVal}</span>`;
  });

  highlighted = highlighted.replace(
    /([,[])\s*(null)/g,
    (match, prefix, nullVal) => {
      const spaces = match.substring(1, match.indexOf(nullVal));
      return `${prefix}${spaces}<span class="text-neutral-500">${nullVal}</span>`;
    },
  );

  highlighted = highlighted.replace(
    /([{}[\],])/g,
    '<span class="text-neutral-400">$1</span>',
  );

  return highlighted;
}
